import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'

import { completeAnimatingIn, completeAnimatingOut, completePreloading, saveNavTheme } from '../../reducers/nav'
import { routes } from '../../constants/routes'
import anime from 'animejs/lib/anime.es.js'
import { Link, useNavigate } from 'react-router-dom'

import { calcComponentState, generateInitialPolygons } from '../../fxs/component-utils'

import HomeMobile from './home-mobile'
// import { ReactComponent as CircleStrokeOne } from '../../assets/svgs/circle-01.svg'
import { ReactComponent as CircleStrokeTwo } from '../../assets/svgs/circle-02.svg'
import { ReactComponent as CircleStrokeThree } from '../../assets/svgs/circle-03.svg'
import { ReactComponent as CircleStrokeFour } from '../../assets/svgs/circle-04.svg'
import { ReactComponent as CircleStrokeFive } from '../../assets/svgs/circle-05.svg'
import { setMusicSource } from '../../reducers/sound'

const TARGET_SVGS = [
    {
        id: 'murphys',
        start: [0, 1000],
        middle: [[0, 403], [174, 359], [239, 286], [336, 387], [376, 467], [449, 798], [472, 1000], [0, 1000]],
        end: [[0, 0], [500, 0], [1000, 0], [1000, 300], [1000, 700], [1000, 1000], [500, 1000], [0, 1000]],
        out: [[1000, 0], [1000, 0], [1000, 0], [1000, 0], [1000, 700], [1000, 900], [1000, 750], [1000, 300]],
        zDepth: 0,
        vertices: 8
    },
    {
        id: 'clayville',
        start: [600, 1000],
        middle: [[325, 397], [554, 309], [777, 363], [819, 680], [806, 826], [734, 1000], [432, 1000]],
        end: [[0, 0], [500, 0], [1000, 0], [1000, 500], [1000, 1000], [500, 1000], [0, 1000]],
        out: [[1000, 0], [1000, 0], [1000, 0], [1000, 500], [1000, 800], [1000, 650], [1000, 10]],
        zDepth: 0,
        vertices: 7
    },
    {
        id: 'spirit-stays-free',
        start: [1000, 1000],
        middle: [[815, 673], [922, 609], [1000, 650], [1000, 1000], [734, 1000], [807, 819]],
        end: [[0, 0], [1000, 0], [1000, 500], [1000, 1000], [500, 1000], [0, 1000]],
        out: [[0, 450], [0, 400], [0, 500], [0, 950], [0, 900], [0, 700]],
        zDepth: 0,
        vertices: 6
    },
    {
        id: 'key-issues',
        start: [1000, 400],
        middle: [[802, 207], [1000, 177], [1000, 648], [975, 661], [815, 675], [762, 337]],
        end: [[0, 0], [1000, 0], [1000, 500], [1000, 1000], [500, 1000], [0, 1000]],
        out: [[0, 100], [0, 250], [0, 900], [0, 950], [0, 900], [0, 1000]],
        zDepth: 0,
        vertices: 6
    },
    {
        id: 'systemic-racism',
        start: [500, 0],
        middle: [[220, 0], [853, 0], [832, 338], [794, 408], [545, 330], [331, 430], [248, 357], [237, 273]],
        end: [[0, 0], [1000, 0], [1000, 300], [1000, 700], [1000, 1000], [300, 1000], [0, 1000], [0, 500]],
        out: [[1000, 100], [1000, 150], [1000, 300], [1000, 700], [1000, 600], [1000, 700], [1000, 750], [1000, 800]],
        zDepth: 0,
        vertices: 8
    },
    {
        id: 'menu',
        start: [1000, 0],
        middle: [[828, 0], [1000, 0], [1000, 258], [813, 244]],
        end: [],
        zDepth: 0,
        vertices: 4
    }
]

const mapStateToProps = (state) => {
    const { nav } = state
    const { deviceType, width, height } = state.ui
    return {
        navState: nav,
        uiDeviceType: deviceType,
        uiWidth: width,
        uiHeight: height
    }
}

const Home = ({ dispatch, navState, uiWidth, uiHeight, uiDeviceType }) => {
    const componentName = 'Home'
    const [polygons, setPolygons] = useState(generateInitialPolygons(TARGET_SVGS, uiWidth, uiHeight))
    const [activeClip, setActiveClip] = useState('')
    const [showOutro, setShowOutro] = useState(false)
    const [outroSmallTxt, setOutroSmallTxt] = useState('')
    const [outroLargeTxt, setOutroLargeTxt] = useState('')
    const navigate = useNavigate()

    const componentState = useMemo(() => {
        return calcComponentState(componentName, navState)
    }, [navState, componentName])

    useEffect(() => {
        if (componentState === 'PRELOADING') {
            handlePreloadingState()
        } else if (componentState === 'ANIMATING_IN') {
            handleAnimatingInState()
        } else if (componentState === 'ACTIVE') {
            if (uiDeviceType !== 'mobile' && uiDeviceType !== 'tablet' && uiDeviceType !== 'intermediate' && navState.theme !== 'white') {
                dispatch(saveNavTheme('white'))
            } else if (navState.theme !== 'grey') {
                dispatch(saveNavTheme('grey'))
            }
        } else if (componentState === 'ANIMATING_OUT_STAGED') {
            handleAnimatingOutStagedState()
        } else if (componentState === 'ANIMATING_OUT') {
            handleAnimatingOutState()
        }
    }, [componentState, uiDeviceType])

    useEffect(() => {
        adjustPolygons(uiWidth, uiHeight)
    }, [uiWidth, uiHeight])

    const handlePreloadingState = async () => {
        setShowOutro(false)
        setActiveClip(null)
        dispatch(completePreloading())
    }

    const handleAnimatingInState = async () => {
        dispatch(setMusicSource('https://api.wayouttanoway.com/sites/default/files/2025-02/Fatima-Concept-6-v2.mp3'))
        animateToMiddle()
        dispatch(completeAnimatingIn())
    }

    const handleAnimatingOutStagedState = () => {
        swipeOff()
    }

    const handleAnimatingOutState = () => {
        setPolygons(generateInitialPolygons(TARGET_SVGS, uiWidth, uiHeight))
        dispatch(completeAnimatingOut())
    }

    const animateToMiddle = () => {
        TARGET_SVGS.forEach(target => {
            let points = []
            for (let i = 0; i < target.middle.length; i = i + 1) {
                points.push(`${target.middle[i][0] / 10 * uiWidth / 100} ${target.middle[i][1] / 10 * uiHeight / 100}`)
            }
            // make a random int between 5 and 7 inclusive
            const steps = Math.floor(Math.random() * 3) + 5
            anime({
                targets: `#${target.id}-clip-path .${target.id}-clip`,
                points: [
                    { value: `${points.join(' ')}` }
                ],
                easing: `steps(${steps})`,
                duration: 750
            })
        })
    }

    const adjustPolygons = (newWidth, newHeight) => {
        if (componentState === 'ACTIVE') {
            const adjustedPolygons = {}
            TARGET_SVGS.forEach(target => {
                let points = []
                for (let i = 0; i < target.middle.length; i = i + 1) {
                    points.push(`${target.middle[i][0] / 10 * newWidth / 100} ${target.middle[i][1] / 10 * newHeight / 100}`)
                }
                adjustedPolygons[target.id] = points.join(' ')
            })
            setPolygons(adjustedPolygons)
        }
    }

    const swipeOff = async () => {
        // TODO: On animate out, hide the title and animate all plygon points off the right side of the screen
        const animation = await collapseSVG()
        if (animation) {
            animation.finished.then(() => {
                dispatch(completeAnimatingOut())
            })
        } else {
            dispatch(completeAnimatingOut())
        }
    }

    const collapseSVG = async () => {
        setShowOutro(false)
        const target = TARGET_SVGS.find(t => t.id === activeClip)
        if (!target) {
            return false
        }
        let points = []
        for (let i = 0; i < target.out.length; i = i + 1) {
            points.push(`${target.out[i][0] / 10 * uiWidth / 100} ${target.out[i][1] / 10 * uiHeight / 100}`)
        }
        return anime({
            targets: `#${target.id}-clip-path .${target.id}-clip`,
            points: [
                { value: `${points.join(' ')}` }
            ],
            easing: `steps(7)`,
            duration: 350
        })
    }


    const expandSVG = async (targetId) => {
        setActiveClip(targetId)
        // TODO: Should we just hide everything else?
        // get the target object based on the id
        const target = TARGET_SVGS.find(t => t.id === targetId)
        let points = []
        for (let i = 0; i < target.end.length; i = i + 1) {
            points.push(`${target.end[i][0] / 10 * uiWidth / 100} ${target.end[i][1] / 10 * uiHeight / 100}`)
        }
        return anime({
            targets: `#${target.id}-clip-path .${target.id}-clip`,
            points: [
                { value: `${points.join(' ')}` }
            ],
            easing: `steps(7)`,
            duration: 250
        })
    }

    const revealOutroTitle = async () => {
        return anime({
            targets: '.title-wrapper',
            keyframes: [
                { opacity: 1 },
                { opacity: 1 }
            ],
            easing: 'linear',
            duration: 1500
        })
    }

    const activateClip = async (target, path, smallText = null, largeText = null) => {
        // wait for the expandSVG function to complete, then trigger next function
        setOutroSmallTxt(smallText)
        setOutroLargeTxt(largeText)
        const animation = await expandSVG(target)
        animation.finished.then(() => {
            setShowOutro(true)
            handleRevealOutro(path)
        })
    }

    const handleRevealOutro = async (path) => {
        if (uiDeviceType === 'mobile') {
            navigate(path)
        } else {
            const revealOutro = await revealOutroTitle()
            revealOutro.finished.then(() => {
                navigate(path)
            })
        }
    }

    if (componentState === 'OFF' || componentState === 'PRELOADING') {
        return null
    }

    if (uiDeviceType === 'mobile' || uiDeviceType === 'tablet' || uiDeviceType === 'intermediate') {
        return <HomeMobile onActivateClip={activateClip} />
    }

    return (
        <div id="home">
            <div className={`title ${activeClip ? 'inactive' : ''}`}>
                <h1>
                    <span>Way Outta</span><span>No Way</span>
                </h1>
                <p>
                    <Link target="_blank" className="home-cta" to={routes.whyWeAreHere.path}>
                        <span>Why We're Here</span>
                    </Link>
                </p>
                <p>
                    <Link className="home-cta" to={routes.community.path}>
                        <span>Stay in Touch</span>
                    </Link>
                </p>
            </div>

            {/* Outro */}
            <div className={`outro-title ${showOutro ? 'visible' : ''}`}>
                <div className="title-wrapper">
                    <span className="small-title">{outroSmallTxt}</span>
                    <span className="large-title">{outroLargeTxt}</span>
                </div>
            </div>

            {/* The Murphys */}
            <div className={`clips murphys ${activeClip ? activeClip === 'murphys' ? 'active' : 'inactive' : ''}`}>
                <button className="title-cta"
                    onClick={() => activateClip('murphys', routes.murphysIndex.path, 'tales from the', 'east side')}>
                    Tales from<br />
                    the East Side
                    <div className="circle-stroke">
                        <CircleStrokeFive />
                    </div>
                    <div className="hp-description">
                        Get to know the friends and family of Clayville's east side. See how systemic racism shapes the experience of their everyday lives.
                    </div>
                </button>
                <div id="murphys-bg" className="bg-photo"
                    onClick={() => activateClip('murphys', routes.murphysIndex.path, 'tales from', 'the east side')}
                >
                    <img id="murphys-01" className="bg-tile" src="/homepage/hp-murphys-01.png" alt="Murphy Background 1" />
                    <img id="murphys-02" className="bg-tile" src="/homepage/hp-murphys-02.png" alt="Murphy Background 2" />
                </div>
                <svg>
                    <defs>
                        <clipPath id="murphys-clip-path">
                            <polygon className="murphys-clip" points={polygons.murphys} />
                        </clipPath>
                    </defs>
                </svg>
            </div>

            {/* The Clayville */}
            <div className={`clips clayville ${activeClip ? activeClip === 'clayville' ? 'active' : 'inactive' : ''}`}>
                <button className="title-cta"
                    onClick={() => activateClip('clayville', routes.clayvilleIndex.path, 'explore', 'clayville')}>
                    Discover<br />
                    Clayville
                    <div className="circle-stroke">
                        <CircleStrokeTwo />
                    </div>
                    <div className="hp-description">
                        Explore the city of Clayville. Visit key landmarks that structure the city's segregated resources and communities.
                    </div>
                </button>
                <div id="clayville-bg" className="bg-photo"
                    onClick={() => activateClip('clayville', routes.clayvilleIndex.path, 'explore', 'clayville')}
                >
                    <img id="clayville-01" className="bg-tile" src="/homepage/hp-clayville-01.png" alt="clayville background 1" />
                    <img id="clayville-02" className="bg-tile" src="/homepage/hp-clayville-02.png" alt="clayville background 2" />
                    <img id="clayville-03" className="bg-tile" src="/homepage/hp-clayville-03.png" alt="clayville background 3" />
                </div>
                <svg>
                    <defs>
                        <clipPath id="clayville-clip-path">
                            <polygon className="clayville-clip" points={polygons.clayville} />
                        </clipPath>
                    </defs>
                </svg>
            </div>

            {/* Spirit Stays Free, formerly Site Guides */}
            <div className={`clips spirit-stays-free ${activeClip ? activeClip === 'spirit-stays-free' ? 'active' : 'inactive' : ''}`}>
                <button className="title-cta"
                    onClick={() => activateClip('spirit-stays-free', routes.spiritStaysFree.path, 'view', 'spirit stays free')}>
                    Spirit<br />
                    Stays Free
                    <div className="circle-stroke">
                        <CircleStrokeTwo />
                    </div>
                    <div className="hp-description">
                        The Black artists and activists featured here inspire us.
                    </div>
                </button>
                <div id="spirit-stays-free-bg" className="bg-photo"
                    onClick={() => activateClip('spirit-stays-free', routes.spiritStaysFree.path, '', 'spirit stays free')}
                >
                    <img id="spirit-stays-free-01" className="bg-tile" src="/homepage/hp-site-guides-01.png" alt="spirit stays free background 1" />
                    <img id="spirit-stays-free-02" className="bg-tile" src="/homepage/hp-site-guides-02.png" alt="spirit stays free background 2" />
                    <img id="spirit-stays-free-03" className="bg-tile" src="/homepage/hp-site-guides-03.png" alt="spirit stays free background 3" />
                    <img id="spirit-stays-free-04" className="bg-tile" src="/homepage/hp-site-guides-04.png" alt="spirit stays free background 4" />
                    <img id="spirit-stays-free-05" className="bg-tile" src="/homepage/hp-site-guides-05.png" alt="spirit stays free background 5" />
                </div>
                <svg>
                    <defs>
                        <clipPath id="spirit-stays-free-clip-path">
                            <polygon className="spirit-stays-free-clip" points={polygons['spirit-stays-free']} />
                        </clipPath>
                    </defs>
                </svg>
            </div>

            {/* Key Issues */}
            <div className={`clips key-issues ${activeClip ? activeClip === 'key-issues' ? 'active' : 'inactive' : ''}`}>
                <button className="title-cta"
                    onClick={() => activateClip('key-issues', routes.keyIssuesIndex.path, 'Explore', 'Key Issues')}>
                    Explore Key<br />
                    Issues
                    <div className="circle-stroke">
                        <CircleStrokeFour />
                    </div>
                    <div className="hp-description">
                        Everyday policies and practices fuel and maintain systemic racism.
                    </div>
                </button>
                <div id="key-issues-bg" className="bg-photo"
                    onClick={() => activateClip('key-issues', routes.keyIssuesIndex.path, 'Explore', 'Key Issues')}
                >
                    <img id="key-issues-01" className="bg-tile" src="/homepage/hp-key-issues-01.png" alt="key issue background 1" />
                    <img id="key-issues-02" className="bg-tile" src="/homepage/hp-key-issues-02.png" alt="key issue background 2" />
                    <img id="key-issues-03" className="bg-tile" src="/homepage/hp-key-issues-03.png" alt="key issues background 3" />
                    <img id="key-issues-04" className="bg-tile" src="/homepage/hp-key-issues-04.png" alt="key issue background 4" />
                </div>
                <svg>
                    <defs>
                        <clipPath id="key-issues-clip-path">
                            <polygon className="key-issues-clip" points={polygons['key-issues']} />
                        </clipPath>
                    </defs>
                </svg>
            </div>

            {/* Systemic Racism */}
            <div className={`clips systemic-racism ${activeClip ? activeClip === 'systemic-racism' ? 'active' : 'inactive' : ''}`}>
                <button className="title-cta"
                    onClick={() => activateClip('systemic-racism', routes.systemicRacismExplained.path, 'Systemic Racism', 'Explained')}>
                    Systemic<br />
                    Racism<br />
                    Explained
                    <div className="circle-stroke">
                        <CircleStrokeThree />
                    </div>
                    <div className="hp-description">
                        Why a systems approach is essential to understand racism.
                    </div>
                </button>
                <div id="systemic-racism-bg" className="bg-photo"
                    onClick={() => activateClip('systemic-racism', routes.systemicRacismExplained.path, 'Systemic Racism', 'Explained')}>
                    <img id="systemic-racism-01" className="bg-tile" src="/homepage/hp-systemic-racism-01.png" alt="systemic racism background 1" />
                    <img id="systemic-racism-02" className="bg-tile" src="/homepage/hp-systemic-racism-02.png" alt="systemic racism background 2" />
                    <img id="systemic-racism-03" className="bg-tile" src="/homepage/hp-key-issues-02.png" alt="systemic racism background 3" />
                </div>
                <svg>
                    <defs>
                        <clipPath id="systemic-racism-clip-path">
                            <polygon className="systemic-racism-clip" points={polygons['systemic-racism']} />
                        </clipPath>
                    </defs>
                </svg>
            </div>

            {/* Menu */}
            <div className={`clips menu ${activeClip ? 'inactive' : ''}`}>
                <span className="title-cta">
                    Menu
                </span>
                <svg>
                    <defs>
                        <clipPath id="menu-clip-path">
                            <polygon className="menu-clip" points={polygons.menu} />
                        </clipPath>
                    </defs>
                </svg>
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(Home)
